import { VERSION } from './version'
import ServiceFactory from './infra/service-factory'
import Logger from './appl/logger'
import HeaderBiddingAdService from './appl/header-bidding-ad-service'

export namespace QLifeHeaderBidding {
    // DOMContentLoaded が完了していたら即時実行、まだならイベント登録
    function waitForReady(callback: Command) {
        if (document.readyState !== 'loading') {
            callback()
            return
        }
        Logger.debug('ドキュメントの初期表示を待機しています')
        const handler = () => {
            Logger.debug('ドキュメントの初期表示が完了しました')
            callback()
            window.removeEventListener('DOMContentLoaded', handler)
        }
        window.addEventListener('DOMContentLoaded', handler)
    }

    /**
     * 入札完了後に初期表示を行う。
     * @param service
     */
    function displayAdsFunc(service: HeaderBiddingAdService) {
        return () => {
            service.deliveryInitialAds()
            Logger.timeEnd('初期表示広告枠の配信')
            service.observeLazyLoadSlots()
        }
    }

    export function start(config: HeaderBiddingConfig) {
        Logger.info(`version ${VERSION}`)
        Logger.time('初期表示広告枠の配信')
        // DOM に依存しないので先にインスタンスを生成しておく。
        const service = ServiceFactory.create(config)
        // 初期表示広告枠の入札開始
        service.requestInitialBids(() => waitForReady(displayAdsFunc(service)))
    }
}
